import React from "react";
import { Logo } from "./Logo";

export function SideNav({ sections, active, onJump, progress, viewedIds }) {
  return (
    <nav
      data-testid="side-nav"
      className="hidden lg:flex fixed top-0 left-0 z-30 h-screen w-60 flex-col border-r border-line bg-ink"
    >
      <div className="flex items-center gap-2 px-6 py-5 border-b border-line">
        <Logo imgClass="h-9" />
      </div>

      <div className="px-6 py-3 border-b border-line">
        <div className="flex items-center justify-between font-mono-data text-xs uppercase tracking-wider text-ftext3 mb-2">
          <span>Progress</span>
          <span data-testid="progress-pct" className="text-sky">{Math.round(progress)}%</span>
        </div>
        <div className="h-1 w-full bg-line">
          <div
            className="h-1 bg-sky transition-[width] duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <ol className="flex-1 overflow-y-auto py-4">
        {sections.map((s, i) => {
          const isActive = active === s.id;
          const isViewed = viewedIds?.has(s.id);
          return (
            <li key={s.id}>
              <button
                data-testid={`nav-${s.id}`}
                onClick={() => onJump(s.id)}
                className="group flex w-full items-center gap-3 px-6 py-2.5 text-left transition-colors"
              >
                <span
                  className={`font-mono-data text-xs w-5 shrink-0 ${
                    isActive ? "text-sky" : "text-ftext3"
                  }`}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span
                  className={`h-4 w-px shrink-0 transition-colors ${
                    isActive ? "bg-sky" : isViewed ? "bg-line2" : "bg-line"
                  }`}
                />
                <span
                  className={`text-sm transition-colors ${
                    isActive
                      ? "text-ftext font-medium"
                      : "text-ftext2 group-hover:text-ftext"
                  }`}
                >
                  {s.label}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
